/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { Input, ModalHeader, ModalBody, ModalFooter, Button } from '@nextui-org/react';
import { IconEye, IconEyeOff } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import { MarketingService } from '../../../../../services';

const ModalChangePassword = ({ user, onSuccess, onClose }) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => setIsVisible(!isVisible);
  const { form, onChange, onSubmit } = useForm(user);

  const submit = async () => {
    const isSuccess = await onSubmit(form);
    if (isSuccess) onSuccess();
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Cambiar Contraseña</ModalHeader>
      <ModalBody>
        <Input
          classNames={{ inputWrapper: 'border-1 h-12' }}
          label="Contraseña"
          variant="bordered"
          type={isVisible ? "text" : "password"}
          value={form.password}
          onValueChange={v => onChange(v, 'password')}
          endContent={
            <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
              {isVisible ? (
                <IconEyeOff className="w-6 h-6" />
              ) : (
                <IconEye className="w-6 h-6" />
              )}
            </button>
          }
        />
        <Input
          classNames={{ inputWrapper: 'border-1 h-12' }}
          label="Confirmar Contraseña"
          variant="bordered"
          type={isVisible ? "text" : "password"}
          value={form.password_confirmation}
          onValueChange={v => onChange(v, 'password_confirmation')}
          endContent={
            <button className="focus:outline-none" type="button" onClick={toggleVisibility}>
              {isVisible ? (
                <IconEyeOff className="w-6 h-6" />
              ) : (
                <IconEye className="w-6 h-6" />
              )}
            </button>
          }
        />
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (user) => {
  const initialForm = {
    id: user?.id,
    password: '',
    password_confirmation: '',
  };

  const [form, setForm] = useState(initialForm);

  const onChange = (value, target) => {
    setForm(s => ({
      ...s,
      [target]: value,
    }));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = (user) => {
    if (!user.password)
      return onError('Debe ingresar la nueva contraseña');

    if (user.password !== user.password_confirmation)
      return onError('Las contraseñas no coinciden');

    return true;
  }

  const onSubmit = async (user) => {
    if (!isValidForm(user)) return;
    try {
      await MarketingService.user.updatePassword(user);
      toast.success('Contraseña actualizada correctamente');
      return true;

    } catch (error) {
      onError(String(error));
      return false;
    }
  }

  return {form, onChange, onSubmit }
}

export default ModalChangePassword;
